import { Box, Stack, TextField } from "@mui/material"
import PasswordStrength, { MIN_PASSWORD_LENGTH, passwordAccepted } from "../components/PasswordStrength"

export { MIN_PASSWORD_LENGTH, passwordAccepted }

/**
 * A new password and its confirmation.
 *
 * One message per field, and only the field at fault carries it.
 *
 * This screen used to state a single fault four times: a page-level red alert, a
 * red `helperText` under the field, a strength bar and a static helper line, all
 * rendered at once. The bar was pulled up with a negative margin to sit where
 * the helper goes, which worked exactly as long as there was no helper text to
 * collide with — so the first time somebody typed a short password, "At least 10
 * characters" appeared and the meter was drawn straight through it.
 *
 * The count in the message is deliberate. "At least 10 characters" is a rule;
 * "that is 2 more" is an instruction, and it updates on every keystroke so the
 * number is always the one that applies right now.
 */
export default function PasswordFields({ password, confirm, onPasswordChange, onConfirmChange, disabled, autoFocus }) {
  const tooShort = password.length > 0 && password.length < MIN_PASSWORD_LENGTH
  const mismatch = confirm.length > 0 && password !== confirm

  return (
    <Stack spacing={2}>
      <Box>
        <TextField
          label="New password"
          type="password"
          value={password}
          onChange={(e) => onPasswordChange(e.target.value)}
          autoComplete="new-password"
          autoFocus={autoFocus}
          disabled={disabled}
          required
          fullWidth
          error={tooShort}
          helperText={tooShort ? `At least ${MIN_PASSWORD_LENGTH} characters — that is ${MIN_PASSWORD_LENGTH - password.length} more.` : undefined}
        />
        <PasswordStrength value={password} />
      </Box>

      <TextField
        label="Confirm password"
        type="password"
        value={confirm}
        onChange={(e) => onConfirmChange(e.target.value)}
        autoComplete="new-password"
        disabled={disabled}
        required
        fullWidth
        error={mismatch}
        helperText={mismatch ? "These do not match" : undefined}
      />
    </Stack>
  )
}
